module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$can(_vm.domain + '.destroy')) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "title": "Remover"
    },
    on: {
      "click": function($event) {
        _vm.onDestroy(_vm.item)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e3859290!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/list/DeleteButton.vue
// module id = 788
// module chunks = 2